// @flow
import classNames from 'classnames';
import type { Element } from 'react';
import React from 'react';
import SortableTable from '#components/support/table/SortableTable/index.jsx';
import modelColumn from '#components/pages/Components/Component/sections/ModelUsage/ModelUsageTable/columns/modelColumn.jsx';
import projectColumn from '#components/pages/Models/Dashboard/ModelsTable/columns/projectColumn.jsx';
import authorColumn from '#components/pages/Models/Dashboard/ModelsTable/columns/authorColumn.jsx';
import createdDateColumn from '#components/pages/Models/Dashboard/ModelsTable/columns/createdDateColumn.jsx';
import updatedDateColumn from '#components/pages/Models/Dashboard/ModelsTable/columns/updatedDateColumn.jsx';
import warningsColumn from '#components/pages/Components/Component/sections/ModelUsage/ModelUsageTable/columns/warningsColumn.jsx';

// Convert react-table v6 columns to TanStack Table v8 format
const convertColumn = (oldColumn: any) => {
  const { id, accessor, Header, Cell, width, sortable = true, additionalClasses = [] } = oldColumn;

  return {
    id,
    accessorKey: typeof accessor === 'string' ? accessor : undefined,
    accessorFn: typeof accessor === 'function' ? accessor : undefined,
    header: Header,
    size: width,
    enableSorting: sortable,
    cell: Cell
      ? info => (
          <Cell value={info.getValue()} original={info.row.original} row={info.row.original} />
        )
      : undefined,
    meta: {
      className: classNames(...additionalClasses, id),
    },
  };
};

const useColumns = () =>
  React.useMemo(
    () =>
      [
        modelColumn,
        projectColumn,
        authorColumn,
        createdDateColumn,
        updatedDateColumn,
        warningsColumn,
      ].map(convertColumn),
    []
  );

type Props = {
  models: Object,
};

const ModelUsageTable = ({ models }: Props): Element<typeof SortableTable> => {
  const columns = useColumns();

  const getRowId = React.useCallback(row => `rowForModel-${row.uuid}`, []);

  return (
    <SortableTable
      data={models}
      columns={columns}
      initialSorting={[]}
      className="model-usage-table"
      getRowId={getRowId}
      tableId="model-usage-table"
      fixedHeight="700px"
    />
  );
};

export default ModelUsageTable;
